
import { store } from '@/store/index.js'
import { useMsal } from '@/composition-api/useMsal.js'
import { loginRequest  } from "@/adAuth-config"
import { InteractionRequiredAuthError } from "@azure/msal-browser"

export const  azureADAuthentication = async() => {
    const { instance } = useMsal()

    // Ensure there is an active account before calling acquireTokenSilent.
    // If no active account is set but there are accounts available, set the first one as active.
    // If no accounts exist, fall back to interactive login.
    let activeAccount = instance.getActiveAccount()
    if (!activeAccount) {
        const accounts = instance.getAllAccounts()
        if (accounts && accounts.length > 0) {
            instance.setActiveAccount(accounts[0])
            activeAccount = accounts[0]
        } else {
            // No account available in cache — start interactive login
            await instance.loginRedirect(loginRequest)
            return
        }
    }

    const request = {
        ...loginRequest,
        account: activeAccount
    }

    const response = await instance.acquireTokenSilent(request).catch(async (e) => {
        // Interaction required will trigger redirect flow
        if (e instanceof InteractionRequiredAuthError) {
            await instance.acquireTokenRedirect(request)
            return
        }

        // For particular 'no_account_error' cases, try to set active account and retry once.
        if (e.errorMessage && e.errorMessage.indexOf('no_account_error') !== -1) {
            const accounts = instance.getAllAccounts()
            if (accounts && accounts.length > 0) {
                instance.setActiveAccount(accounts[0])
                const retryReq = { ...request, account: accounts[0] }
                return await instance.acquireTokenSilent(retryReq)
            }
            await instance.loginRedirect(loginRequest)
            return
        }

        throw e
    })

    if (!response) return

    // User info from Azure AD
    console.log('Hi, ' + response.account.username + '. Welcome to Product Analytics! ')
    console.log('Your AD-Groups roles are:' + JSON.stringify(response.idTokenClaims.roles))
    localStorage.setItem('yourAdRoles', response.idTokenClaims.roles)
    store.commit('setUsername', response.account.username)
    store.commit('setBearerToken', response.accessToken)
    store.commit('setIsFreudUser', response.idTokenClaims.roles?.includes("Freud_standard") ? true : false)
    store.commit('setIsOptOutProductUser', response.idTokenClaims.roles?.includes("Gen-OptOutProducts") ? true : false)
    store.commit('setIsRnDAdvancedAnalysisPlatform', response.idTokenClaims.roles?.includes("RnDAdvancedAnalysisPlatform") ? true : false)
    store.commit('setIsODP_limited', response.idTokenClaims.roles?.includes("ODP_limited") ? true : false)
    store.commit('setIsODP_unlimited', response.idTokenClaims.roles?.includes("ODP_unlimited") ? true : false)
    store.commit('setIsRnDemployee', response.idTokenClaims.roles?.includes("RnDemployee") ? true : false)
    store.commit('setIsRnDconsultant', response.idTokenClaims.roles?.includes("RnDconsultant") ? true : false)
    store.commit('setIsYQI_Users', response.idTokenClaims.roles?.includes("YQI_Users") ? true : false)
    store.commit('setIsGUIUsersTst', response.idTokenClaims.roles?.includes("GUIUsersTst") ? true : false)
    store.commit('setIsAP3610001CLAPUsers', response.idTokenClaims.roles?.includes("AP3610001-CLAPUsers") ? true : false)
    store.commit('setIsAP3610001CLAPAdmins', response.idTokenClaims.roles?.includes("AP3610001-CLAPAdmins") ? true : false)
    store.commit('setUserCanExportData', (response.idTokenClaims.roles?.includes("Product_Analytics_Download")||response.idTokenClaims.roles?.includes("RnDAdvancedAnalysisPlatform")) ? true : false)
}
